class CartDrawerRecommendations extends HTMLElement {
  constructor() {
    super();
    this.sectionId = 'cart-drawer-recommendations';
    this.limit = parseInt(this.dataset.limit) || 4;
    
    console.log('CartDrawerRecommendations: Custom element registered');
  }

  connectedCallback() {
    this.init();
    this.observeCartDrawer();
  }

  observeCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (cartDrawer.classList.contains('active')) {
            setTimeout(() => this.init(), 100);
          }
        }
      });
    });

    observer.observe(cartDrawer, { attributes: true });
  }

  init() {
    console.log('CartDrawerRecommendations: Initializing...');
    
    const productId = this.getProductId();
    if (!productId) {
      console.log('CartDrawerRecommendations: No product ID found');
      return;
    }

    console.log('CartDrawerRecommendations: Found product ID:', productId);
    this.fetchRecommendations(productId);
  }

  getProductId() {
    // Try to get product ID from cart items
    const cartItems = document.querySelectorAll('[data-cart-item][data-product-id]');
    if (cartItems.length > 0) {
      return cartItems[0].dataset.productId;
    }

    // Fallback: extract from first product link
    const firstItemLink = document.querySelector('.cart-item a[href*="/products/"]');
    if (firstItemLink) {
      const match = firstItemLink.href.match(/\/products\/([^?\/]+)/);
      if (match) {
        // Need to convert handle to ID - fetch product data
        return this.getProductIdFromHandle(match[1]);
      }
    }

    return null;
  }

  async getProductIdFromHandle(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();
      return product.id;
    } catch (error) {
      console.error('Error getting product ID:', error);
      return null;
    }
  }

  async fetchRecommendations(productId) {
    try {
      console.log('CartDrawerRecommendations: Fetching server-rendered section for product:', productId);
      
      // Fetch the section with server-side rendered HTML
      // This includes properly formatted prices!
      const url = `/recommendations/products?section_id=${this.sectionId}&product_id=${productId}&limit=${this.limit}`;
      
      const response = await fetch(url);
      const text = await response.text();
      
      console.log('CartDrawerRecommendations: Received HTML response');
      
      // Parse the HTML response
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      
      // Find the rendered recommendations
      const renderedContent = doc.querySelector('[data-cart-recommendations-rendered]');
      
      if (renderedContent && renderedContent.querySelectorAll('.cart-drawer__recommendations-item').length > 0) {
        console.log('CartDrawerRecommendations: Found rendered content, inserting into DOM');
        this.innerHTML = renderedContent.outerHTML;
        
        // Attach event listeners after inserting HTML
        this.attachEventListeners();
        
        console.log('CartDrawerRecommendations: Render complete');
      } else {
        console.log('CartDrawerRecommendations: No recommendations found in response');
      }
    } catch (error) {
      console.error('CartDrawerRecommendations: Error fetching recommendations:', error);
    }
  }

  attachEventListeners() {
    // Arrow navigation
    this.attachArrowListeners();

    // Add to cart links (for single-variant products)
    const addToCartLinks = this.querySelectorAll('.cart-rec-link--add-to-cart');
    addToCartLinks.forEach(link => {
      link.addEventListener('click', (e) => this.handleAddToCart(e, link));
    });
  }

  attachArrowListeners() {
    const slider = this.querySelector('.cart-drawer__recommendations-slider');
    const prevButton = this.querySelector('.cart-drawer__recommendations-arrow--prev');
    const nextButton = this.querySelector('.cart-drawer__recommendations-arrow--next');

    if (!slider || !prevButton || !nextButton) return;

    const scrollAmount = slider.offsetWidth * 0.8;

    prevButton.addEventListener('click', () => {
      slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    nextButton.addEventListener('click', () => {
      slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }

  async handleAddToCart(e, link) {
    e.preventDefault();

    const variantId = link.dataset.variantId;
    if (!variantId) return;

    // Visual feedback - change text temporarily
    const originalText = link.textContent;
    link.textContent = 'Adding...';
    link.style.pointerEvents = 'none';

    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        link.textContent = 'Added!';
        await this.refreshCart();
        
        // Reset after 2 seconds
        setTimeout(() => {
          link.textContent = originalText;
          link.style.pointerEvents = '';
        }, 2000);
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      link.textContent = 'Error - Try again';
      setTimeout(() => {
        link.textContent = originalText;
        link.style.pointerEvents = '';
      }, 2000);
    }
  }

  async refreshCart() {
    try {
      const response = await fetch('/?section_id=cart-drawer');
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const newDrawerInner = doc.querySelector('.drawer__inner');
      const currentDrawerInner = document.querySelector('cart-drawer .drawer__inner');
      
      if (newDrawerInner && currentDrawerInner) {
        currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
        
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.renderContents(await (await fetch('/?sections=cart-drawer,cart-icon-bubble')).json());
        }

        const drawerInner = document.querySelector('cart-drawer .drawer__inner');
        if (drawerInner) {
          drawerInner.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    } catch (error) {
      console.error('Error refreshing cart:', error);
    }
  }
}

if (!customElements.get('cart-drawer-recommendations')) {
  customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
  console.log('CartDrawerRecommendations: Custom element registered');
}